export enum ProductType {
  UserLicense = 1,
  Tool = 2,
}
